/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PrivacidadeAliases {
  CARD_AVISO = 'card-aviso',
  CARD_TERMO = 'card-termo',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  CONTEXTUAL_BAR_TERMO = 'contextual-bar-termo',
  FETCH_0 = 'fetch-0',
  FETCH_AVISO = 'fetch-aviso',
  FETCH_STATUS = 'fetch-status',
  FETCH_STATUS_TERMO = 'fetch-status-termo',
  FETCH_TERMO = 'fetch-termo',
  FIELD_AVISO = 'field-aviso',
  FIELD_AVISO_TEXTO = 'field-aviso-texto',
  FIELD_AVISO_VIGENCIA = 'field-aviso-vigencia',
  FIELD_TERMO = 'field-termo',
  FIELD_TERMO_TEXTO = 'field-termo-texto',
  FIELD_TERMO_VIGENCIA = 'field-termo-vigencia',
  FORM_0 = 'form-0',
  FORM_1 = 'form-1',
  HPMS_DYNAMIC_CONTENT_FIELD = 'hpms-dynamic-content-field',
  HPMS_DYNAMIC_CONTENT_FIELD_TERMO = 'hpms-dynamic-content-field-termo',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  HPMS_TEXT_HTML_AVISO = 'hpms-text-html-aviso',
  HPMS_TEXT_HTML_TERMO = 'hpms-text-html-termo',
  LAYOUT_0 = 'layout-0',
  MODAL_DESCRICAO = 'modal-descricao',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_AVISO = 'panel-aviso',
  PANEL_AVISO_TEXTO = 'panel-aviso-texto',
  PANEL_MODAL_DESCRICAO = 'panel-modal-descricao',
  PANEL_TERMO = 'panel-termo',
  PANEL_TERMO_TEXTO = 'panel-termo-texto',
  TEXT_AVISO = 'text-aviso',
  TEXT_AVISO_VIGENCIA = 'text-aviso-vigencia',
  TEXT_TERMO = 'text-termo',
  TEXT_TERMO_VIGENCIA = 'text-termo-vigencia',
}
export { PrivacidadeAliases };
